<template>
  <div class="mantenimiento-page">
    <div class="mantenimiento-hero">
      <h2>Servidor Fuera de Servicio</h2>
      <p class="intro-quote">"Gogo aprecia el tiempo que pasó contigo."</p>
    </div>

    <div class="mantenimiento-body">
      <div class="stat-block">
        <span class="stat-number">7</span>
        <p class="stat-text">maravillosos usuarios ofrecieron su confianza a Gogo.</p>
      </div>

      <div class="message-block">
        <p>Sin embargo, Gogo se encuentra meditando y volverá pronto con más funciones que nunca.</p>
        <p class="reward-text">Gracias por confiar en Gogo, esa confianza te será recompensada.</p>
      </div>

      <div class="image-block">
        <img src="@/assets/gogoranger.jpg" alt="Servidor fuera de servicio" class="ranger-image" />
      </div>

      <div class="actions">
        <router-link to="/" class="btn-home">
          Regresar al Inicio
        </router-link>
      </div>
    </div>

    <AdSense />
  </div>
</template>

<script>
import AdSense from './AdSense.vue';

export default {
  name: "AppLogin",
  components: {
    AdSense
  }
};
</script>

<style scoped>
.mantenimiento-page {
  background-color: #121212;
  color: #ffffff;
  min-height: calc(100vh - 70px);
  width: 100%;
}

.mantenimiento-hero {
  background-color: #7289da; /* Blurple de Discord de la landing */
  text-align: center;
  padding: 80px 20px;
  color: #ffffff;
}

.mantenimiento-hero h2 {
  font-size: 2.5rem;
  margin: 0 0 15px 0;
  font-weight: bold;
}

.intro-quote {
  font-style: italic;
  font-size: 1.25rem;
  margin: 0;
  color: #ffffff;
  opacity: 0.9;
}

.mantenimiento-body {
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
  text-align: center;
}

.stat-block {
  background-color: #2c2c2c; /* Gris de secciones de la landing */
  padding: 30px;
  border-radius: 5px;
  margin-bottom: 30px;
  border: 1px solid #333;
}

.stat-number {
  font-size: 5rem;
  font-weight: bold;
  color: #ffd700; /* Oro plano */
  display: block;
  line-height: 1;
  margin-bottom: 10px;
}

.stat-text {
  font-size: 1.1rem;
  margin: 0;
  color: #ffffff;
}

.message-block {
  font-size: 1.15rem;
  line-height: 1.6;
  margin-bottom: 30px;
}

.reward-text {
  color: #ffd700;
  font-weight: bold;
  margin-top: 15px;
}

.image-block {
  margin: 30px 0;
}

.ranger-image {
  max-width: 100%;
  width: 350px;
  height: auto;
  border: 3px solid #7289da;
  border-radius: 5px;
}

.actions {
  margin: 40px 0;
}

.btn-home {
  display: inline-block;
  background-color: #7289da;
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 5px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s;
}

.btn-home:hover {
  background-color: #5b6eae;
}
</style>

